import React from "react";
import townhouseImage from "../townHouse.jpeg"; // replace with your image path

const TownHall = () => {
  return (
    <div className="townhouse-section">
      <div className="content">
        <div className="image">
          <img src={townhouseImage} alt="Townhouse" />
        </div>
        <div className="text">
          <p>
            Townhouses come in a variety of designs, ranging from contemporary developments with a wide range of architectural styles to historic row houses with homogeneous facades. They frequently have several floors, with bedrooms on the higher stories and living areas on the ground. A community or homeowners association (HOA), which oversees the upkeep of properties, outward appearance, and usage of shared facilities, may impose rules and regulations on members of townhouse projects. In addition to gardening and snow removal, HOAs occasionally offer recreational amenities like parks or pools.
          </p>
          <button className="contact-btn">Contact Us</button>
        </div>

      </div>
    </div>
  );
};

export default TownHall;
